<pcs-text-field textFieldValue="fileUpload.selectedFiles"
                textFieldStyle="Bold"
                textFieldSize="small">
</pcs-text-field>
<div class="file-list d-flex align-items-start" *ngFor="let file of files; let i = index;">
  <pcs-text-field [textFieldValue]="file.name"
                  textFieldSize="small"
                  class="col h-auto lh-1 p-0 text-break">
  </pcs-text-field>
  <pcs-text-field [textFieldValue]="file.size | fileSize"
                  textFieldSize="small"
                  textFieldStyle="Info"
                  class="ms-auto h-auto lh-1 col-auto">
  </pcs-text-field>
  <pcs-icon icon="delete_forever" (click)="removed.emit(i)"></pcs-icon>
</div>
